module.exports = __webpack_public_path__ + "static/media/metallic-chirp.3cd125bd.mp3";